export default function () {
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/enquiries/enquiriesCtrl.js